import React, { useEffect, useState } from "react";
import { getJobs, submitJob } from "../api/client";

const Careers = ({ settings, lang }) => {
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null); // 'success', 'error'

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getJobs();
                setJobs(response.data || []);
            } catch (error) {
                console.error("Failed to fetch jobs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSubmissionStatus(null);

        const formData = new FormData(e.target);

        try {
            await submitJob(formData);
            setSubmissionStatus("success");
            e.target.reset();
        } catch (error) {
            console.error("Submission failed:", error);
            setSubmissionStatus("error");
        } finally {
            setSubmitting(false);
        }
    };

    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_careers", "إينوبريدج - الوظائف");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_careers", "إينوبريدج - عنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_careers", "إينوبريدج - عنا"));
        }
    }, [lang, settings]);
    const getText = (en, ar) => (lang === "en" ? en : ar);


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            <header className="py-5 bg-body header header1">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("contact_title", "Contact Us") /* Note: Blade used 'contact_title' but page is Careers. Keeping as is or 'Join Our Team' equivalent if available in data */}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("contact_desc", "We'd love to hear from you...")}
                    </p>
                </div>
            </header>

            <section className="py-5 bg-card">
                <div className="container py-4">

                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {lang === "en" ? "Our Work Culture" : "بيئة العمل لدينا"}
                        </h2>
                        <p className="text-muted fs-5">
                            {lang === "en"
                                ? "Experience a workplace where innovation meets collaboration"
                                : "اختبر بيئة عمل حيث يلتقي الابتكار بالتعاون"}
                        </p>
                    </div>

                    <div className="row g-4 align-items-center">

                        {/* Icons Grid */}
                        <div className="col-lg-6" data-aos="fade-up">
                            <div className="row g-3">

                                {/* Item 1 */}
                                <div className="col-6">
                                    <div className="bg-body p-4 text-center shadowP" style={{ borderRadius: 12 }}>
                                        <div className="mb-3">
                                            <i className="ri-team-line text-primary" style={{ fontSize: 48 }}></i>
                                        </div>
                                        <h6 className="fw-bold mb-2">
                                            {lang === "en" ? "Collaborative" : "تعاوني"}
                                        </h6>
                                        <p className="small text-muted mb-0">
                                            {lang === "en" ? "Teamwork at its best" : "العمل الجماعي في أفضل حالاته"}
                                        </p>
                                    </div>
                                </div>

                                {/* Item 2 */}
                                <div className="col-6">
                                    <div className="bg-body p-4 text-center shadowP" style={{ borderRadius: 12 }}>
                                        <div className="mb-3">
                                            <i className="ri-lightbulb-flash-line text-primary" style={{ fontSize: 48 }}></i>
                                        </div>
                                        <h6 className="fw-bold mb-2">
                                            {lang === "en" ? "Innovative" : "مبتكر"}
                                        </h6>
                                        <p className="small text-muted mb-0">
                                            {lang === "en" ? "Creative solutions" : "حلول إبداعية"}
                                        </p>
                                    </div>
                                </div>

                                {/* Item 3 */}
                                <div className="col-6">
                                    <div className="bg-body p-4 text-center shadowP" style={{ borderRadius: 12 }}>
                                        <div className="mb-3">
                                            <i className="ri-scales-3-line text-primary" style={{ fontSize: 48 }}></i>
                                        </div>
                                        <h6 className="fw-bold mb-2">
                                            {lang === "en" ? "Balanced" : "متوازن"}
                                        </h6>
                                        <p className="small text-muted mb-0">
                                            {lang === "en" ? "Work-life harmony" : "توازن الحياة والعمل"}
                                        </p>
                                    </div>
                                </div>

                                {/* Item 4 */}
                                <div className="col-6">
                                    <div className="bg-body p-4 text-center shadowP" style={{ borderRadius: 12 }}>
                                        <div className="mb-3">
                                            <i className="ri-rocket-2-line text-primary" style={{ fontSize: 48 }}></i>
                                        </div>
                                        <h6 className="fw-bold mb-2">
                                            {lang === "en" ? "Growth-Focused" : "موجه للنمو"}
                                        </h6>
                                        <p className="small text-muted mb-0">
                                            {lang === "en" ? "Continuous learning" : "تعلم مستمر"}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Right Side Text */}
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">

                            <h3 className="fw-bold mb-4">
                                {lang === "en"
                                    ? "Why You'll Love Working Here"
                                    : "لماذا ستحب العمل هنا"}
                            </h3>

                            <p className="mb-4">
                                {lang === "en"
                                    ? "At InnoBridge, we believe that great work comes from great people in a great environment. Our culture is built on trust, respect, and the shared goal of making a meaningful impact."
                                    : "في InnoBridge، نؤمن بأن العمل العظيم يأتي من أشخاص عظماء في بيئة عظيمة. ثقافتنا مبنية على الثقة والاحترام والهدف المشترك لإحداث تأثير ذي معنى."}
                            </p>

                            <ul className="list-unstyled">
                                <li className="mb-3 d-flex align-items-start">
                                    <i className="ri-check-line text-primary fs-5 me-3 mt-1"></i>
                                    <div>
                                        <strong>
                                            {lang === "en" ? "Open Communication" : "تواصل مفتوح"}
                                        </strong>
                                        <p className="text-muted small mb-0">
                                            {lang === "en"
                                                ? "Your voice matters and ideas are always welcome"
                                                : "صوتك مهم والأفكار دائماً موضع ترحيب"}
                                        </p>
                                    </div>
                                </li>

                                <li className="mb-3 d-flex align-items-start">
                                    <i className="ri-check-line text-primary fs-5 me-3 mt-1"></i>
                                    <div>
                                        <strong>
                                            {lang === "en" ? "Diverse & Inclusive" : "متنوع وشامل"}
                                        </strong>
                                        <p className="text-muted small mb-0">
                                            {lang === "en"
                                                ? "We celebrate different perspectives and backgrounds"
                                                : "نحتفل بوجهات النظر والخلفيات المختلفة"}
                                        </p>
                                    </div>
                                </li>

                                <li className="mb-3 d-flex align-items-start">
                                    <i className="ri-check-line text-primary fs-5 me-3 mt-1"></i>
                                    <div>
                                        <strong>
                                            {lang === "en" ? "Impact-Driven" : "موجه بالتأثير"}
                                        </strong>
                                        <p className="text-muted small mb-0">
                                            {lang === "en"
                                                ? "Work on projects that make a real difference"
                                                : "اعمل على مشاريع تحدث فرقاً حقيقياً"}
                                        </p>
                                    </div>
                                </li>
                            </ul>

                        </div>

                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container py-4">

                    {/* Section Title */}
                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {lang === "en" ? "Why Join InnoBridge?" : "لماذا تنضم إلى InnoBridge؟"}
                        </h2>

                        <p className="text-muted fs-5">
                            {lang === "en"
                                ? "Competitive benefits designed to support your success"
                                : "مزايا تنافسية مصممة لدعم نجاحك"}
                        </p>
                    </div>

                    <div className="row g-4">

                        {/* Benefit 1 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-money-dollar-circle-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Competitive Salary" : "راتب تنافسي"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Industry-leading compensation packages with performance bonuses and annual reviews."
                                        : "حزم تعويضات رائدة في الصناعة مع مكافآت الأداء والمراجعات السنوية."}
                                </p>
                            </div>
                        </div>

                        {/* Benefit 2 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-health-book-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Health Insurance" : "تأمين صحي"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Comprehensive health coverage for you and your family, including dental and vision."
                                        : "تغطية صحية شاملة لك ولعائلتك، بما في ذلك الأسنان والرؤية."}
                                </p>
                            </div>
                        </div>

                        {/* Benefit 3 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-time-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Flexible Hours" : "ساعات عمل مرنة"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Work when you're most productive with flexible scheduling and remote work options."
                                        : "اعمل عندما تكون أكثر إنتاجية مع جدولة مرنة وخيارات العمل عن بُعد."}
                                </p>
                            </div>
                        </div>

                        {/* Benefit 4 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-quill-pen-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Learning & Development" : "التعلم والتطوير"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Access to training programs, conferences, and certifications to advance your career."
                                        : "الوصول إلى برامج التدريب والمؤتمرات والشهادات لتطوير مسيرتك المهنية."}
                                </p>
                            </div>
                        </div>

                        {/* Benefit 5 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-plane-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Paid Time Off" : "إجازة مدفوعة"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Generous vacation days, sick leave, and public holidays to recharge and relax."
                                        : "أيام إجازة سخية، وإجازة مرضية، وعطلات رسمية لإعادة الشحن والاسترخاء."}
                                </p>
                            </div>
                        </div>

                        {/* Benefit 6 */}
                        <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                            <div className="h-100 p-4 bg-card shadowP rounded-3">
                                <div className="mb-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3">
                                        <i className="ri-trophy-line" style={{ fontSize: 40 }}></i>
                                    </div>
                                </div>

                                <h5 className="fw-bold mb-3">
                                    {lang === "en" ? "Career Growth" : "النمو الوظيفي"}
                                </h5>

                                <p className="text-muted mb-0">
                                    {lang === "en"
                                        ? "Clear career paths with mentorship programs and opportunities for advancement."
                                        : "مسارات وظيفية واضحة مع برامج الإرشاد وفرص التقدم."}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Open Positions */}
            <section className="py-5 bg-card">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2 text-muted">{getText("Loading positions...", "جاري تحميل الوظائف...")}</p>
                        </div>
                    ) : (
                        <>
                            {jobs.length > 0 ? (
                                <h3 className="fw-bold mb-4" data-aos="fade-up">{getText("Open Positions", "الوظائف المتاحة")}</h3>
                            ) : (
                                <h3 className="fw-bold mb-4 w-100 text-center" data-aos="fade-up">{getText("There are no jobs available right now.", "لا يوجد وظائف الان")}</h3>
                            )}
                            <div className="row gy-4 justify-content-center">
                                {jobs.map((j, i) => (
                                    <div className="col-md-6" data-aos="fade-up" key={i}>
                                        <div className="card-custom h-100">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <h5 className="fw-bold">{lang === 'en' ? j.title_en : j.title_ar}</h5>
                                                {(j.type_en || j.type_ar) && (
                                                    <span className="badge bg-primary text-dark">{lang === 'en' ? j.type_en : j.type_ar}</span>
                                                )}
                                            </div>
                                            <p className="text-muted mb-4">{lang === 'en' ? j.description_en : j.description_ar}</p>
                                            <a href="#apply" className="btn btn-outline-custom btn-sm">{getText("Apply Now", "قدم الآن")}</a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>

                    )}
                </div>
            </section>

            {/* Application Form */}
            <section className="py-5 bg-body" id="apply">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8" data-aos="fade-up">
                            <div className="card-custom bg-card">
                                <h3 className="fw-bold mb-4">{getText("Submit Your Application", "قدم طلبك")}</h3>
                                <p className="text-muted small mb-3">
                                    {getText(
                                        "You may apply for a suitable position...",
                                        "يمكنك التقدّم على وظيفة مناسبة..."
                                    )}
                                </p>
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Full Name", "الاسم الكامل")}</label>
                                            <input type="text" className="form-control bg-body" name="name" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Phone Number", "رقم الهاتف")}</label>
                                            <input type="tel" className="form-control bg-body" name="phone" required pattern="[0-9]+" onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Gmail / Email", "البريد الإلكتروني / جيميل")}</label>
                                            <input type="email" className="form-control bg-body" name="gmail" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Country", "الدولة")}</label>
                                            <input type="text" className="form-control bg-body" name="country" required />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label">{getText("Address", "العنوان")}</label>
                                            <input type="text" className="form-control bg-body" name="address" required />
                                        </div>
                                        {jobs.length > 0 && (
                                            <div className="col-12">
                                                <label className="form-label">{getText("Choose a job", "اختر الوظيفة")}</label>
                                                <select className="form-control bg-body" name="job">
                                                    <option value=""></option>
                                                    {jobs.map((j) => (
                                                        <option key={j.id} value={j.id}>{lang === 'en' ? j.title_en : j.title_ar}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Job Title", "المسمى الوظيفي")}</label>
                                            <input type="text" className="form-control bg-body" required name="jobTitle" />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">{getText("Upload CV (PDF)", "رفع السيرة الذاتية (PDF)")}</label>
                                            <input type="file" className="form-control bg-body" accept=".pdf" required name="file" />
                                        </div>
                                        <div className="col-12 mt-5">
                                            <button type="submit" className="py-2 btn btn-primary-custom w-100" disabled={submitting}>
                                                {submitting ? getText("Submitting...", "جاري الإرسال...") : getText("Submit Application", "إرسال الطلب")}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Process Overlay Modal (Simplified) */}
            {(submitting || submissionStatus) && (
                <section className="modal process-overlay show" id="processOverlay">
                    <div className="process-modal">
                        {submitting && (
                            <div id="processState">
                                <div className="spinner-border text-primary" role="status"></div>
                                <h5 className="mt-3">{getText("Your request is being processed...", "جاري معالجة الطلب...")}</h5>
                            </div>
                        )}
                        {!submitting && submissionStatus === "error" && (
                            <div id="feildState">
                                <div className="checkmark" style={{ background: 'rgba(255, 84, 89, 1)' }}><i className="ri-error-warning-line"></i></div>
                                <h5>{getText("Error Occurred", "حدث خطأ")}</h5>
                                <p className="text-muted mt-2">{getText("Please try again", "برجاء المحاوله مره اخرى")}</p>
                                <button className="btn btn-primary-custom w-100" onClick={() => setSubmissionStatus(null)}>{getText("Done", "موافق")}</button>
                            </div>
                        )}
                        {!submitting && submissionStatus === "success" && (
                            <div id="successState">
                                <div className="checkmark"><i className="ri-check-double-line"></i></div>
                                <h5>{getText("Sent successfully", "تم الارسال بنجاح")}</h5>
                                <p className="text-muted mt-2">{getText("You will be contacted soon.", "سوف يتم التواصل معك قريباً")}</p>
                                <button className="btn btn-primary-custom w-100" onClick={() => setSubmissionStatus(null)}>{getText("Done", "موافق")}</button>
                            </div>
                        )}
                    </div>
                </section>
            )}

            {/* Styles for modal are expected to be in CSS, if specific styles were in blade head/body they need to be moved to CSS file or styled-components. 
          Assuming global CSS has them, but the blade had inline styles for #processOverlay mechanism. 
          I'll add inline styles here to ensure it works. 
      */}
            <style>{`
        #processOverlay {
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            z-index: 99999;
            position: fixed;
            width: 100%;
            height: 100%;
            background: #0000008c;
            left: 0;
        }
        .process-modal {
            background: var(--bg-card, #fff);
            border-radius: 16px;
            padding: 24px;
            width: min(520px, 92vw);
            text-align: center;
            box-shadow: 0 20px 60px rgba(0, 0, 0, .25);
        }
        .checkmark {
            width: 72px;
            height: 72px;
            border-radius: 50%;
            background: var(--bg-card, #fff); /* Fallback */
            color: #fff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 36px;
            box-shadow: 0 10px 20px rgba(40, 167, 69, .35);
            margin: 12px 0;
        }
      `}</style>
        </>
    );
};

export default Careers;
